import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Box, Typography } from '@material-ui/core';
import useStyles from './SideMenuListItem.styles';
import { ISideMenuItem } from '../../../types/interfaces/ISideMenuItem';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

const SideMenuListItem: React.FC<ISideMenuItem> = ({
  icon,
  label,
  path,
  dropdownItems,
  expanded,
  onClick,
  isDropdownItem
}) => {
  const styles = useStyles();
  return dropdownItems ? (
    <>
      <Box className={styles.menuItem} onClick={onClick}>
        <Box className={clsx(styles.iconContainer, !expanded && styles.iconColor)}>{icon}</Box>
        <Typography variant="subtitle2" className={styles.menuItemLabel}>{label}</Typography>
        {expanded ? (
          <ExpandLessIcon className={styles.dropDownIcon} />
        ) : (
          <ExpandMoreIcon className={styles.dropDownIcon} />
        )}
      </Box>
      {expanded && dropdownItems && dropdownItems.length && (
        <Box>
          {dropdownItems.map((props) => (
            <SideMenuListItem key={props.label} {...props} />
          ))}
        </Box>
      )}
    </>
  ) : (
    <NavLink
      to={path || ''}
      className={clsx(styles.menuItem, isDropdownItem && styles.dropDownItemPadding)}
      activeClassName={clsx(styles.menuItem, isDropdownItem && styles.dropDownItemPadding, styles.activeMenuItem)}
      replace={true}
    >
      <Box className={clsx(styles.iconContainer, styles.iconColor)}>{icon}</Box>
      <Typography variant="subtitle2" className={styles.menuItemLabel}>
        {label}
      </Typography>
    </NavLink>
  );
};

export default SideMenuListItem;
